import { Suspense } from "react"

import type { PropsWithClassName } from "~/@types/generics"
import ProductDetailsPrice from "~/components/ui/ProductHeader/components/ProductDetails/components/ProductDetailsPrice"
import ClientProductDetailsPriceWithVariantSwitch from "~/app/[locale]/products/[slug]/(components)/ProductDetailsPriceWithVariantSwitch/index.client"
import type { useVariantSwitch } from "~/app/[locale]/products/[slug]/(hooks)/useVariantSwitch"

export type ProductDetailsPriceWithVariantSwitchProps = PropsWithClassName<Parameters<typeof useVariantSwitch>[0]>

function ProductDetailsPriceWithVariantSwitch(props: ProductDetailsPriceWithVariantSwitchProps) {
  return (
    <Suspense
      fallback={props.defaultVariant && <ProductDetailsPrice className={props.className} {...props.defaultVariant} />}
    >
      <ClientProductDetailsPriceWithVariantSwitch {...props} />
    </Suspense>
  )
}

export default ProductDetailsPriceWithVariantSwitch
